import { shop } from '@/commonTypes';
import styles from './styles.module.css';
import { Breadcrumb } from '@/components/general/BreadCrumb';
import MainIcons from '@/icons/main';
import ReserveButton from '@/components/pages/service/SingleServiceContent/ServiceCard/ReserveButton';
import InfoCard from '@/components/pages/profile/ProfileContent/AccountHero/InfoCard';
import RateComponent from '@/components/common/RateComponent';
import Button from '@/components/common/Button';

const ShopHero = ({ shop }: { shop: shop }) => {
  //   const randomHue = Math.floor(Math.random() * 360);
  const randomHue = Math.floor(Math.random() * (290 - 210) + 210);
  const stats = [
    {
      id: 2,
      text: shop?.productCount,
      title: 'کالای موجود',
      unit: '',
    },
    {
      id: 3,

      text: shop?.serviceCount,
      title: 'خدمت قابل رزرو',
      unit: '',
    },
    {
      id: 4,

      text: shop?.rating,
      title: 'امتیاز کاربران',
      unit: '',
    },
    {
      id: 5,

      text: shop?.closestTime,
      title: 'نزدیک‌ترین نوبت',
      unit: '',
    },
  ];

  const badges = [
    {
      label: shop?.category?.title,
      className: styles.categoryBadge,
    },
    {
      label: 'باز است',
      className: styles.openBadge,
    },
    {
      label: 'اصالت کالا',
      className: styles.authBadge,
    },
  ];

  return (
    <section className={styles.hero} style={{ '--h': randomHue } as React.CSSProperties}>
      <div className={`${styles.heroBg}`}>
        <div className={`${styles.container} container`}>
          <Breadcrumb
            items={[
              { label: 'کارا', to: '/' },
              { label: 'فروشگاه‌ها و مراکز', to: '/shops' },
              { label: shop?.title || '' },
            ]}
            className={styles.breadcrumb}
            currentStyle={styles.current}
          />

          {/* Header */}
          <div className={styles.header}>
            <div className={styles.info}>
              <div className={styles.logo}>
                <MainIcons.shopIcon fill="var(--paper)" width="40px" height="40px" />
              </div>

              <div>
                <div className={styles.badges}>
                  {badges?.map((badge) => (
                    <span key={badge.label} className={badge.className}>
                      {badge.label}
                    </span>
                  ))}
                </div>

                <h1 className={styles.title}>{shop?.title}</h1>

                <div className={styles.meta}>
                  <div className={styles.item}>
                    <RateComponent
                      rate={Number(shop?.rating)}
                      widgetDimensions="14px"
                      readOnly={true}
                      number={1}
                    />
                    {shop?.rating}
                  </div>

                  <div className={styles.item}>
                    <MainIcons.locationIcon
                      width="15px"
                      height="15px"
                      fill="rgba(255, 255, 255, 0.88)"
                    />{' '}
                    {shop?.city?.name} {shop?.address} · {shop?.distance}
                  </div>

                  <div className={styles.item}>
                    <MainIcons.clockIcon
                      width="15px"
                      height="15px"
                      fill="rgba(255, 255, 255, 0.88)"
                    />
                    {shop?.openTime}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.actions}>
              <ReserveButton
                className={styles.primaryButton}
                item={shop}
                type="shop"
                fill={'var(--danger)'}
              />

              <Button href="tel:02122345678" className={`squareButton ${styles.secondaryButton}`}>
                <MainIcons.phoneIcon fill="var(--paper)" width="17px" height="17px" />
                تماس با فروشگاه
              </Button>
            </div>
          </div>

          <div className={styles.stats}>
            {stats?.map((item, index) => (
              <InfoCard
                item={item}
                key={index}
                className={styles.statCard}
                statValueClass={styles.statValue}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopHero;
